<div class="switcher">
    <p-selectButton [options]="layoutOptions" [(ngModel)]="selectedLayout" (ngModelChange)="setLayout($event)"></p-selectButton>
</div>
